import dayjs from 'dayjs'

export const formatAuditTimestamp = (timestamp) => {
  if (!timestamp) return '-'
  return dayjs(timestamp).format('M/DD/YY HH:mm') + ' hrs'
}

export const formatEventType = (eventType) => {
  if (!eventType) return '-'
  const eventMap = {
    UPDATE: 'Updated',
    CREATE: 'Created',
    INSERT: 'Created',
    DELETE: 'Deleted'
  }
  return eventMap[eventType.toUpperCase()] || eventType
}

export const formatUserRoles = (userRoles) => {
  if (!userRoles || userRoles.length === 0) return '-'
  return Array.isArray(userRoles) ? userRoles.join(', ') : userRoles
}

export const formatChangedDataValues = (property, changedData) => {
  if (!changedData || (Array.isArray(changedData) && changedData.length === 0)) {
    return '-'
  }

  if (property?.toLowerCase() === 'permission') {
    return 'View Permission'
  }

  // Handle string values
  if (typeof changedData === 'string') {
    return changedData.trim() || '-'
  }

  // Handle non-array values
  if (!Array.isArray(changedData)) {
    return String(changedData) || '-'
  }

  const values = changedData.filter((item) => typeof item === 'string' && item.trim() !== '')
  return values.length > 0 ? values.join(', ') : '-'
}

export const CLIENT_AUDIT_COLUMNS = [
  {id: 'property', label: 'Property', minWidth: 140},
  {id: 'event', label: 'Event', minWidth: 120},
  {id: 'clientId', label: 'Client ID', minWidth: 100},
  {
    id: 'afterChange',
    label: 'After change',
    minWidth: 150,
    truncatedContentInfo: 'Hover over the short names to view full content'
  },
  {id: 'timestamp', label: 'Timestamp', minWidth: 160},
  {id: 'modifierEmail', label: 'Modifier Email', minWidth: 180},
  {id: 'modifierRole', label: 'Modifier Role', minWidth: 140}
]

export const transformAuditClientToRow = (client, index) => {
  return {
    id: index + 1,
    clientId: client.CLIENT_ID || '-',
    property: client.PROPERTY || '-',
    event: formatEventType(client.EVENT_TYPE),
    afterChange: formatChangedDataValues(client.PROPERTY, client.CHANGED_DATA),
    timestamp: formatAuditTimestamp(client.AUDITED_AT),
    modifierEmail: client.CHANGED_BY || '-',
    modifierRole: formatUserRoles(client.USER_ROLE),
    changedData: client.CHANGED_DATA || []
  }
}

export const transformClientAuditDataToTableFormat = (auditData) => {
  if (!auditData?.getAuditDetails?.clients) {
    return {
      columns: CLIENT_AUDIT_COLUMNS,
      rows: [],
      pagination: {page: 1, pageSize: 5, totalCount: 0}
    }
  }

  const {clients, page, pageSize, totalCount} = auditData.getAuditDetails
  const rows = clients.map((client, index) => transformAuditClientToRow(client, index))

  return {
    columns: CLIENT_AUDIT_COLUMNS,
    rows,
    pagination: {page, pageSize, totalCount}
  }
}

export default transformClientAuditDataToTableFormat
